import axios from 'axios'
import library from '../../../utils/Library'

export const UpdateParameterApplicationInstance = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') +
    '/UpdateParameterApplicationInstanceEAuthz'
  return await axios({
    url: URL,
    method: 'PUT',
    data: body,
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
